<script>
	import { navigate } from "svelte-routing";

	export let row = {};
	export let key = "";
	export let className = "";
	export let flagKey = "flagged";
	export let flagValue = "Yes";
	export let linkBy = "";
	export let linkTo = "";
	export let event = undefined;

	function handleClick(domEvent) {
		if (linkTo) {
			domEvent.stopPropagation();
			navigate(`${linkTo}${row[linkBy || key]}`);
		} else if (event) {
			domEvent.stopPropagation();
			event(row);
		}
	}
</script>

<button
	type="button"
	class={`${className} flagged-value-button`}
	on:click={handleClick}
>
	{row[key] || "-"}
	{#if row[flagKey] === flagValue}
		<img
			src="/assets/icon-alert-filled-red.svg"
			alt="Flagged"
			class="flag-icon"
		/>
	{/if}
</button>

<style>
	.flagged-value-button {
		white-space: nowrap;
		background: none;
		border: none;
		padding: 0;
		font: inherit;
		text-align: inherit;
		cursor: pointer;
	}

	.flag-icon {
		width: 24px;
		height: 24px;
		margin-left: 4px;
		vertical-align: -0.125em;
	}
</style>
